import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiAlertTriangle, FiLock, FiArrowRight } = FiIcons;

const Notice = () => {
  return (
    <section className="py-16 bg-yellow-50 border-t-4 border-yellow-400">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          className="text-center"
        >
          <div className="flex justify-center mb-6">
            <SafeIcon icon={FiAlertTriangle} className="h-12 w-12 text-yellow-600" />
          </div>
          
          <div className="space-y-4 text-gray-700 max-w-4xl mx-auto">
            <p className="text-lg leading-relaxed">
              <strong>⚠️ Notice:</strong> This website is created only for student practice. Account4Web experts have not fixed 
              technical issues here – so you can clearly see the real work level of students. Almost 80% of the website 
              is perfect, and the remaining 20% is polished by experts in final projects.
            </p>
            
            <p className="text-lg leading-relaxed flex items-center justify-center gap-2">
              <SafeIcon icon={FiLock} className="h-5 w-5 text-green-600" />
              <strong>🔒</strong> We never share any client website made under this offer with others – your project privacy is 100% safe.
            </p>
            
            <motion.div
              whileHover={{ scale: 1.05 }}
              className="mt-8"
            >
              <a
                href="https://projects.azaansuperpc.com/"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 bg-blue-600 text-white px-8 py-3 rounded-full font-semibold hover:bg-blue-700 transition-colors shadow-lg"
              >
                👉 Check Offer
                <SafeIcon icon={FiArrowRight} className="h-5 w-5" />
              </a>
            </motion.div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Notice;